module.exports = __webpack_public_path__ + "static/media/ma.69fb3d36.svg";